class OkendoQuiz extends HTMLElement {
	constructor() {
		super();

		this.subtitle = this.getAttribute('subtitle');
		this.buttonLabel = this.getAttribute('button-label');

		const observer = new MutationObserver(_ => {
			// Modify subtitle and button
			const subtitleElem = this.querySelector('.c-startPanel-subtitle')
			if (this.subtitle && subtitleElem && subtitleElem.dataset.modified != 'true') {
				subtitleElem.innerHTML = this.subtitle;
				subtitleElem.dataset.modified = 'true';
			}

			const buttonElem = this.querySelector('.c-startPanel-button');
			if (this.buttonLabel && buttonElem && buttonElem.dataset.modified != 'true') {
				buttonElem.innerHTML = this.buttonLabel;
				buttonElem.dataset.modified = 'true';
			}

			// Insert quick add to cart and price elements
			for (const rec of this.querySelectorAll('.c-recommendedProduct')) {
				if (rec.dataset.modified === 'true') continue;
				
				const link = rec.querySelector('a[href*="/products/"]');
				if (!link) continue;

				const url = new URL(link.href);
				const handle = url.pathname.split('/')[2];
				
				const qatc = document.createElement('quick-add-to-cart');
				qatc.dataset.handle = handle;
				qatc.innerHTML = 'Add to Cart';
				rec.appendChild(qatc);

				const qatcButton = qatc.cloneNode(true);
				qatcButton.setAttribute('is-button', '');
				rec.appendChild(qatcButton);

				const priceElem = rec.querySelector('.c-recommendedProduct-price a');
				priceElem.innerHTML = '';

				const dynamicPrice = document.createElement('dynamic-price');
				dynamicPrice.dataset.handle = handle;
				priceElem.appendChild(dynamicPrice);

				rec.dataset.modified = 'true';
			}

			// Add our own list and carousel arrows
			for (const products of this.querySelectorAll('.l-products')) {
				if (products.dataset.modified === 'true') continue;

				const list = document.createElement('ul');
				list.className = 'bt-okendo-quiz__products';
				products.appendChild(list);

				products.insertAdjacentHTML('afterbegin', '<carousel-arrow direction="prev" target=".bt-okendo-quiz__products"></carousel-arrow>')
				products.insertAdjacentHTML('beforeend', '<carousel-arrow direction="next" target=".bt-okendo-quiz__products"></carousel-arrow>')

				products.dataset.modified = true;
			}

			// Extract products from product rows
			const rows = this.querySelectorAll('.l-productRow');
			const list = this.querySelector('.bt-okendo-quiz__products');

			if (rows.length > 0) {
				list.innerHTML = '';
			}

			for (const row of rows) {
				for (const product of row.querySelectorAll('.c-recommendedProduct')) {
					list.appendChild(product);
				}

				row.remove();
			}
		});

		observer.observe(this, { childList: true, subtree: true });
	}
}

customElements.define('bt-okendo-quiz', OkendoQuiz);